import SmartLookClient from 'smartlook-client';

const { REACT_APP_SMART_LOOK_KEY } = process.env;

export default class SmartLook {
  static client: SmartLookClientType;

  constructor() {
    if (!REACT_APP_SMART_LOOK_KEY) {
      console.error('smartlook key not defined');
    }
    REACT_APP_SMART_LOOK_KEY &&
      SmartLook.createInstance(REACT_APP_SMART_LOOK_KEY);
  }

  static createInstance = (key: string) => {
    if (key && SmartLookClient.init(key)) {
      SmartLook.client = SmartLookClient;
      return;
    }
    console.error('smartlook key not defined');
  };

  public static handleIdentify = (userId: string, userInfo: userInfo) => {
    if (!SmartLook.client) {
      new SmartLook();
    }
    SmartLook.client && SmartLook.client.identify(userId, userInfo);
  };

  public static handleDisable = () => {
    SmartLook.client && SmartLookClient.disable();
  };
}
